import videoUrlParser from 'js-video-url-parser';

// Unified function to parse video URLs and extract all necessary information
export const parseVideoUrl = (url) => {
    if (!url) return null;

    try {
        const parsed = videoUrlParser.parse(url);
        if (parsed) {
            return {
                provider: parsed.provider,
                id: parsed.id,
                params: parsed.params || {},
                mediaType: parsed.mediaType || 'video'
            };
        }
    } catch (error) {
        console.error('Error parsing video URL:', error);
    }

    return null;
};

// Extracts YouTube video ID from the given URL
export const getYtVideoId = (url) => {
    const parsed = parseVideoUrl(url);

    return parsed && parsed.provider === 'youtube' ? parsed.id : null;
};

// Extracts Vimeo video ID from the given URL
export const getVimeoVideoId = (url) => {
    const parsed = parseVideoUrl(url);

    return parsed && parsed.provider === 'vimeo' ? parsed.id : null;
};

// Extracts query parameters from a URL
export const extractQueryParams = (url) => {
    const parsed = parseVideoUrl(url);
    if (!parsed || !parsed.params) return {};

    const params = {};

    // Convert string values to appropriate types
    Object.keys(parsed.params).forEach((key) => {
        const value = parsed.params[key];
        if (value === 'true' || value === '1') {
            params[key] = true;
        } else if (value === 'false' || value === '0') {
            params[key] = false;
        } else if (!isNaN(value) && value !== '') {
            params[key] = parseInt(value, 10);
        } else {
            params[key] = value;
        }
    });

    return params;
};
